module.exports = __webpack_public_path__ + "img/product-chaintimingkit-slider.e420aa34.jpg";